import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Upload, TrendingUp, Users, AlertTriangle,
  Settings, BarChart3, FileText
} from 'lucide-react';

import Dashboard from './pages/Dashboard';
import DataUpload from './pages/DataUpload';
import Forecasting from './pages/Forecasting';
import Alerts from './pages/Alerts';
import Reports from './pages/Reports';

function Sidebar() {
  const location = useLocation();

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/upload', icon: Upload, label: 'Upload Data' },
    { path: '/forecasting', icon: TrendingUp, label: 'Forecasting' },
    { path: '/alerts', icon: AlertTriangle, label: 'Alerts' },
    { path: '/reports', icon: FileText, label: 'Reports' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <BarChart3 size={32} />
        <h1>Analytics Pro</h1>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
}

function App() {
  return (
    <Router>
      <div className="app">
        <Sidebar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/upload" element={<DataUpload />} />
            <Route path="/forecasting" element={<Forecasting />} />
            <Route path="/alerts" element={<Alerts />} />
            <Route path="/reports" element={<Reports />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
